/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext } from 'react';
import { Table } from 'reactstrap';

// local  imports
import { ThemeContext } from '../../../contexts/ThemeContext';

const SelectedClient = props => {

    // contexts
    const { theme, fontWeight } = useContext(ThemeContext);

    // logic to display the content
    let element;
    if (props.client) {
        element =
            <>
                <div className="row">
                    <div className="col-sm-3 col-md-3 text-center">
                        <div className="mx-auto text-center" style={{ width: "120px", height: "120px" }}>
                            <img className="m-auto w-100 h-100" src={props.client.clientId.profileImage} alt="My client" style={{ borderRadius: "100%", border: "solid 3px #C4C4C4" }} />
                        </div>
                    </div>

                    <div className="col-sm-9 col-md-9">
                        <Table borderless>
                            <tbody>
                                <tr>
                                    <td>
                                        <span style={{ fontWeight: fontWeight.medium }}>Name</span>
                                    </td>
                                    <td>
                                        <span>{props.client.clientId.title} {props.client.clientId.firstName} {props.client.clientId.lastName}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span style={{ fontWeight: fontWeight.medium }}>Email</span>
                                    </td>
                                    <td>
                                        <span>{props.client.clientId.email}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span style={{ fontWeight: fontWeight.medium }}>Phone</span>
                                    </td>
                                    <td>
                                        <span>+{props.client.clientId.phone}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span style={{ fontWeight: fontWeight.medium }}>Gender</span>
                                    </td>
                                    <td>
                                        <span style={{ textTransform: "capitalize" }}>{props.client.clientId.gender}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
            </>
    } else {
        element =
            <>
                <p style={theme.paragraph}>No Client selected currenly, select one from above dropdown.</p>
            </>
    }

    // function's return
    return (
        <div>
            {element}
        </div>
    )
}

export default SelectedClient;